define('util/getPcAuthToken',[
  "config"
], function (config) {
  'use strict';
  return function () {
    var oAuthToken;
    if (config.appVersion === 'dev') {
      var oAuthKey = 'pc_auth-localhost-dca';
      if (config.env === "tca") {
        oAuthKey = 'pc_auth-localhost-tca';
      } else if (config.env === "sca") {
        oAuthKey = 'pc_auth-localhost-sca';
      } else if (config.env === "pca") {
        oAuthKey = 'pc_auth-localhost-pca';
      }
      oAuthToken = JSON.parse(localStorage[oAuthKey]);
    } else {
      oAuthToken = JSON.parse(localStorage.pc_auth);
    }

    return oAuthToken;
  };
});
